module.exports = __webpack_public_path__ + "img/location_permission.34379a91.svg";